import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/files/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/files/')({
  component: Page,
});
